// extracted by mini-css-extract-plugin
export var card = "_q5-0";
export var content = "_q5-2";
export var details = "_q5-3";
export var icon = "_q5-1";
export var iconBlue = "_q5-5";
export var iconBrand = "_q5-4";
export var iconGrayBlue = "_q5-6";
export var iconGreen = "_q5-7";
export var iconIndigo = "_q5-8";
export var iconOrange = "_q5-9";
export var iconPurple = "_q5-a";
export var iconRed = "_q5-b";
export var iconWarning = "_q5-c";